/*
* A secret menu for debuging and internal info. Press Ctrl + Shift + Alt to open/close
*/
define('secret_menu',['logger', 'utils/dom_helper', 'dialogv2', 'runtime', 'utils/constants'],
  function(Logger, DomHelper, Dialog, Runtime, CONST) {
    var html = [
      '<div class="wrap">',
      '  <div class="innerwrap">',
      '    <div id="close" class="close">&times;</div>',
      '    <h2>Secret Menu</h2>',
      '    <div id="logoutput" class="logoutput"></div>',
      '    <div id="appid"></div>',
      '    <div id="callcount"></div>',
      '    <div id="savesize"></div>',
      '  </div>',
      '</div>'
    ].join('');

    var SecretMenu = {
      open: false,
      init: function() {
        var self = this;

        if (CONST.y8_appid == Runtime.getAppId()) {
          return;
        }

        DomHelper.addEventListener(window, 'keydown', function(e) {
          if (e.shiftKey && e.altKey && e.ctrlKey) {
            if (!self.open) {
              Dialog.loadedCallback = function() {
                var frameDoc = Dialog.iframe.contentWindow.document;
                var output = frameDoc.getElementById('logoutput');
                var appid = frameDoc.getElementById('appid');
                var callCount = frameDoc.getElementById('callcount');
                var saveSize = frameDoc.getElementById('savesize');
                self.closeDiv = frameDoc.getElementById('close');
                DomHelper.addEventListener(self.closeDiv, 'click', self.close);
                output.innerHTML = '';
                for(var i = 0; i < Logger.history.length; i++) {
                  output.innerHTML = output.innerHTML + Logger.history[i];
                }

                appid.innerHTML = Runtime.getAppId();
                callCount.innerHTML = Logger.getCalls() + ' call in last 5 mins';
                saveSize.innerHTML = Logger.getSaveSize() + ' bytes saved last';
              };
              Dialog.create(html, 400, 350);
              Dialog.loadStyle(CONST.cdnUrl + '/dialogv2/secret_menu.css');
              self.open = true;
            } else {
              Dialog.destroy();
              self.open = false;
              DomHelper.removeEventListener(self.closeDiv, 'click', self.close);
            }
          }
        });
      },

      close: function() {
        SecretMenu.open = false;
        Dialog.destroy();
        DomHelper.removeEventListener(SecretMenu.closeDiv, 'click', SecretMenu.close);
      },
    };

    return SecretMenu;
  }
);

